import { memoize } from '@sama/micro-dash';
import { ShapeType } from '../../../team-apis/otterdam/answers/shape-typings';
import { ArrowHelper } from './arrow-helper';
import { Cuboid2DHelper } from './cuboid-2d-helper';
import { KeypointShapeHelper } from './keypoint-shape-helper';
import { LineHelper } from './line-helper';
import { PointHelper } from './point-helper';
import { PolygonHelper } from './polygon-helper';
import { RectangleHelper } from './rectangle-helper';
import { ShapeHelper } from './shape-helper';
import { SliderRectangleHelper } from './slider-rectangle-helper';

// eslint-disable-next-line complexity -- we didn't come up with a better alternative
export const getShapeHelper = memoize((type: ShapeType) => {
  switch (type) {
    case 'arrow':
      return new ArrowHelper();
    case 'cuboid':
      return new Cuboid2DHelper();
    case 'line':
      return new LineHelper();
    case 'keypoint_shape':
      return new KeypointShapeHelper();
    case 'point':
      return new PointHelper();
    case 'polygon':
      return new PolygonHelper();
    case 'rectangle':
      return new RectangleHelper();
    case 'slider_rectangle':
      return new SliderRectangleHelper();
    default:
      return new ShapeHelper();
  }
});
